import { render, staticRenderFns } from "./SdsTableSection2Label.vue?vue&type=template&id=ffa0e232"
import script from "./SdsTableSection2Label.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsTableSection2Label.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports